// extracted by mini-css-extract-plugin
export default {"container":"JobberLogo_container__VZZGf"};